import { PropsWithChildren } from 'react';
import { Header } from '/src/components';

export const DesktopLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <Header />
      <section className="content">
        <section className="container">{children}</section>
      </section>
    </>
  );
};
